import Axios from "./interceptor.service";

export const getTicketStatusReport = async (queryParams) => {
  const response = await Axios.get("/feedback/getCaseStats", {
    params: queryParams,
  });
  return response;
};

export const getTicketPriorityReport = async (queryParams) => {
  const response = await Axios.get("/feedback/getCaseStatusCounts", {
    params: queryParams,
  });
  return response;
};

export const getTicketChannelReport = async (queryParams) => {
  const response = await Axios.get("/feedback/getCaseCounts", {
    params: queryParams,
  });
  return response;
};

export const getSlaReport = async (queryParams) => {
  const response = await Axios.get("/feedback/getAllCaseCounts", {
    params: queryParams,
  });
  return response;
};

export const getDepartmentReport = async (queryParams) => {
  const response = await Axios.get("/feedback/getDbCounts", {
    params: queryParams,
  });
  return response;
};


export const getCategoryReport = async (queryParams) => {
  const response = await Axios.get("/feedback/getCategoryCounts", {
    params: queryParams,
  });
  return response;

};
